import React, { CSSProperties, ReactNode } from 'react'

interface Props {
  children?: ReactNode
  onGrid?: boolean
  allowAnnouncement?: boolean
  isShort?: boolean
  mainStyle?: CSSProperties
}

const Layout: React.FC<Props> = ({ children, mainStyle }) => {
  return (
    <main style={{ height: '100vh', overflow: 'hidden', ...mainStyle }}>
      {children}
    </main>
  )
}

export default Layout
